import React from 'react';
import { useAppDispatch } from '../../../app/hooks';
import PortfolioComposite from '../../../api/models/portfolioComposite';
import DeviationGauge from '../deviation-gauge';
import { instanceToPlain } from 'class-transformer';
import { setSelectedComposite } from './portfolio-detail-slice';
import { componentIdealPercentageString } from '../../../app/utils';

interface PortfolioDetailCompositeCardProps {
  portfolioComposite: PortfolioComposite
}

/**
 * A component to view and select a category from the portfolio.
 */
const PortfolioDetailCompositeSelectionCard: React.FC<PortfolioDetailCompositeCardProps> = (props: PortfolioDetailCompositeCardProps) => {

  // Get the 'dispatch' method from the store
  const dispatch = useAppDispatch();

  function selectComposite(e: React.MouseEvent<HTMLDivElement, MouseEvent>): void {
    dispatch(setSelectedComposite(instanceToPlain(props.portfolioComposite)));
  }

  return (
    <div onClick={selectComposite} className='cursor-pointer select-none flex flex-col h-full rounded-md border text-xs lg:text-sm items-center bg-black/10 border-blue-300/40 shadow-md lg:shadow-lg shadow-slate-900/80 hover:bg-white/15'>

      <div className='flex w-full h-full text-center items-center px-1 lg:px-3 py-1 border-b lg:border-b-2 border-blue-300/40 bg-blue-900/20'>
        <div className='grow text-start'>{props.portfolioComposite.category.name.toUpperCase()}</div>
        <div className='h-2/3 mx-3 border-l lg:border-l-2 border-blue-300/40'></div>
        <div className='flex'>
          <div className='text-end'>{componentIdealPercentageString(props.portfolioComposite)}</div>
        </div>
      </div>

      <DeviationGauge
        deviation={props.portfolioComposite.deviation()}
        deviationLimit={0.3}
        animate={false}
        className='w-10 lg:w-28 pt-2 lg:pt-4'
        valueClassName='text-center w-14 bg-transparent lg:pt-2 pb-1 lg:pb-4 text-nowrap'
      />
    </div >
  )
}

export default PortfolioDetailCompositeSelectionCard;